



































































































































































































































































































































































































































































import Vue, { PropType } from "vue";
import { ValidationObserver } from "vee-validate";
import Invoice from "../../../../types/invoices/Invoice";
import InvoiceLine from "../../../../types/invoices/InvoiceLine";
import currency from "currency.js";
import {
  formatAsMoney,
  parseLocaleNumberQty,
} from "../../../../helpers/format";

interface InvoiceLineViewModel
  extends Omit<InvoiceLine, "price" | "totalVat" | "qty"> {
  qty: string;
  price: string;
  totalVat: string;
}

export default Vue.extend({
  name: "create-invoices-lines",
  props: {
    invoiceData: {
      type: Object as PropType<Invoice>,
      required: true,
    },
  },
  data() {
    return {
      line: {
        description: "",
        qty: "",
        unit: "",
        price: "",
        vat: 0,
        totalVat: "",
      } as InvoiceLineViewModel,
    };
  },
  computed: {
    invoiceLineViewModels() {
      if (this.invoiceData.lines === undefined) {
        return [];
      }
      return this.invoiceData.lines.map(
        (line: InvoiceLine): InvoiceLineViewModel => ({
          description: line.description,
          qty: new Intl.NumberFormat(this.$i18n.i18next.language, {
            useGrouping: false,
          }).format(line.qty),
          unit: line.unit,
          price: new Intl.NumberFormat(this.$i18n.i18next.language, {
            useGrouping: false,
          }).format(line.price.value),
          vat: line.vat,
          totalVat: new Intl.NumberFormat(this.$i18n.i18next.language, {
            useGrouping: false,
          }).format(line.totalVat.value),
        })
      );
    },
  },
  methods: {
    lineTotalWithoutVat(price: string, qty: string) {
      const total = currency(
        parseLocaleNumberQty(price, this.$i18n.i18next.language)
      ).multiply(parseLocaleNumberQty(qty, this.$i18n.i18next.language));

      if (isNaN(total.value)) {
        return 0;
      }

      return formatAsMoney(total.value, "EUR", this.$i18n.i18next.language);
    },
    getUpdatedInvoiceLines() {
      return this.invoiceLineViewModels.map((line: InvoiceLineViewModel) => ({
        description: line.description,
        qty: parseLocaleNumberQty(line.qty, this.$i18n.i18next.language),
        unit: line.unit,
        price: currency(
          parseLocaleNumberQty(line.price, this.$i18n.i18next.language)
        ),
        vat: line.vat,
        totalVat: currency(
          parseLocaleNumberQty(line.totalVat, this.$i18n.i18next.language)
        ),
      }));
    },
    async validate(): Promise<boolean> {
      if (this.invoiceLineViewModels.length === 0) {
        const warn: any = {
          text: this.$t("invoices:empty_lines"),
          type: "warn",
        };
        this.$notify(warn);

        return false;
      }
      let isValid = true;
      for (let index = 0; index < this.invoiceLineViewModels.length; index++) {
        //@ts-ignore
        const validator = (await this.$refs[
          `formEditLine-${index}`
        ][0]) as InstanceType<typeof ValidationObserver>;
        const result = await validator.validate();
        if (!result) {
          isValid = false;
        }
      }
      return isValid;
    },
    deleteLine(index: number) {
      this.invoiceData.lines.splice(index, 1);
      this.$emit("on-line-deleted", this.invoiceData.lines);
    },
    resetLine() {
      this.line.description = "";
      this.line.qty = "";
      this.line.unit =
        this.invoiceData.lines[this.invoiceData.lines.length - 1].unit;
      this.line.price = "";
      this.line.vat =
        this.invoiceData.lines[this.invoiceData.lines.length - 1].vat;
    },
    async sendLine() {
      const result = await (
        this.$refs.formAddLine as InstanceType<typeof ValidationObserver>
      ).validate();

      if (!result) {
        return;
      }
      const subTotal = currency(
        parseLocaleNumberQty(this.line.qty, this.$i18n.i18next.language)
      ).multiply(
        parseLocaleNumberQty(this.line.price, this.$i18n.i18next.language)
      );
      const totalVAT = subTotal.multiply(this.line.vat).divide(100);
      this.line.totalVat = totalVAT.value.toString();

      const transformedLine: InvoiceLine = {
        description: this.line.description,
        qty: parseLocaleNumberQty(this.line.qty, this.$i18n.i18next.language),
        unit: this.line.unit,
        price: currency(
          parseLocaleNumberQty(this.line.price, this.$i18n.i18next.language)
        ),
        vat: this.line.vat,
        totalVat: currency(
          parseLocaleNumberQty(this.line.totalVat, this.$i18n.i18next.language)
        ),
      };
      this.$emit("on-line-created", transformedLine);
      this.resetLine();
      (
        this.$refs.formAddLine as InstanceType<typeof ValidationObserver>
      ).reset();
    },
  },
});
